import React, { lazy } from 'react'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { LazyRoute } from 'Modules'
import { Switch } from 'react-router-dom'

const MerchantBranchesConnectedLazy = lazy(
	() => import('Pages/orders/merchantBranches/components/')
)

export const MerchantBranchesRoutes = () => {
	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.orders.merchant_branches}
				lazyComponent={MerchantBranchesConnectedLazy}
				key={FrontUrls.orders.merchant_branches}
			/>
		</Switch>
	)
}
